export default __webpack_public_path__ + "static/media/infra-bg.38513477.png";